import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncAppleMusicToSpotify() {
    return (
        <GuidesPage
            seoData={seoContent.syncAppleMusicToSpotify}
            sections={<PairSyncGuideContent sourceKey="appleMusic" destKey="spotify" />}
        />
    );
}
